import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import InboxPage from './pages/InboxPage';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { MessageProvider } from './contexts/MessageContext';

import CssBaseline from '@material-ui/core/CssBaseline';
import GlobalStyles from './GlobalStyles';
function App() {
    return (
        <>
            <CssBaseline />
            <GlobalStyles />
            <Router>
                <AuthProvider>
                    <MessageProvider>
                        <Layout>
                            <Routes>
                                <Route path="/login" element={<LoginPage />} />
                                <Route path="/inbox" element={
                                    <PrivateRoute>
                                        <InboxPage />
                                    </PrivateRoute>
                                } />
                                <Route path="/" element={<Navigate to="/inbox" />} />
                            </Routes>
                        </Layout>
                    </MessageProvider>
                </AuthProvider>
            </Router>
        </>
    );
}

function PrivateRoute({ children }) {
    const { isAuthenticated } = useAuth();
    return isAuthenticated ? children : <Navigate to="/login" />;
}

export default App;